import React from 'react';
import { CheckCircle2, Mail, ShieldCheck, UserRound } from 'lucide-react';
import { initials } from './restaurantUtils';

export default function RestaurantProfile({ user }) {
  return (
    <div className="rc-profile">
      <div className="rc-page-heading">
        <div><span className="rc-eyebrow">MI PERFIL</span><h1>Hola, {user?.name || 'cliente'}</h1><p>Tu información se reutiliza de la cuenta PROVI.</p></div>
      </div>
      <section className="rc-profile-card">
        <div className="rc-profile-card__avatar">{initials(user?.name)}</div>
        <div><h2>{user?.name || 'Cliente PROVI'}</h2><p><Mail aria-hidden="true" />{user?.email || 'Correo no disponible'}</p></div>
        <span><CheckCircle2 aria-hidden="true" />Cuenta activa</span>
      </section>
      <section className="rc-profile-options">
        <div><UserRound aria-hidden="true" /><div><strong>Datos personales</strong><p>Gestionados desde tu cuenta principal.</p></div></div>
        <div><ShieldCheck aria-hidden="true" /><div><strong>Seguridad y acceso</strong><p>PROVI usa tu sesión autenticada actual.</p></div></div>
      </section>
    </div>
  );
}
